import {useSearchParams} from 'react-router'

/**
 * `?layout=minimal` — the staff-booking handoff flag.
 *
 * When support builds a booking for a passenger, the deep link they receive carries it:
 * `{base}/rides/{tripId}/confirm?ref=AL-…&layout=minimal` (the `ref` is stripped by
 * RefAuthGate once the passenger is authorised; `layout` stays)
 * (the older links pointed at `/rides/{tripId}/confirm`). The passenger arrives from an
 * SMS or email with no dashboard context and one job: review and confirm. So the flag
 * strips the dashboard chrome — no sidebar, no header — leaving the page alone on the
 * screen.
 *
 * PORTAL-WIDE. It used to be scoped to `/rides/:id/confirm`, which meant the newer
 * `/phone-booking-confirmation` handoff route still rendered with the full chrome. The
 * rule is now simply "the URL says minimal", on every route: a link handed to a
 * passenger strips the chrome wherever it lands. Nothing in the app adds the parameter
 * itself, so it only ever appears on a link that was meant to be minimal.
 *
 * @returns {boolean}
 */
export default function useMinimalLayout() {
    const [searchParams] = useSearchParams()
    return searchParams.get('layout') === 'minimal'
}
